import { FieldProps } from "@rjsf/utils";
import { Number } from "../../Inputs";
import { Input } from "../__styles__/Inputs";

export const NumberInput = (
  props: FieldProps & { isSubmissionBuilder?: boolean },
) => {
  const value = props.formData ?? null;
  const isFormulaField = !!props.schema.formula;
  const disabled = props.disabled || props.readonly;

  return (
    <Input isSubmissionBuilder={props.isSubmissionBuilder}>
      <Number
        name={props.idSchema.$id}
        label={props.schema.title}
        required={props.required && !disabled}
        placeholder={props.uiSchema?.["ui:placeholder"]}
        value={value}
        onChange={props.onChange}
        disabled={false}
        readonly={disabled || isFormulaField}
        helperText={props.uiSchema?.["ui:helperText"]}
        error={props.rawErrors?.join(", ")}
        step={props.uiSchema?.["ui:step"]}
        postfix={props.uiSchema?.["ui:postfix"]}
        prefix={props.uiSchema?.["ui:prefix"]}
        labelSize={props.uiSchema?.["ui:labelSize"]}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
      />
    </Input>
  );
};
